import { appendPath } from '@silverhand/essentials';
import { useTranslation } from 'react-i18next';

enum DocumentationLanguage {
  English = 'en',
}

const normalizeEnv = (value: unknown) =>
  value === null || value === undefined ? undefined : String(value);

const configuredDocumentationSiteUrl = normalizeEnv(import.meta.env.DOCUMENTATION_SITE_URL);
const documentationSiteRoot =
  configuredDocumentationSiteUrl && configuredDocumentationSiteUrl.length > 0
    ? configuredDocumentationSiteUrl
    : 'https://latticeruntime.com/docs';

const useDocumentationUrl = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const documentationSiteUrl = Object.values<string>(DocumentationLanguage)
    .filter((language) => language !== DocumentationLanguage.English)
    .includes(language)
    ? `${documentationSiteRoot}/${language.toLocaleLowerCase()}`
    : documentationSiteRoot;

  return {
    documentationSiteUrl,
    getDocumentationUrl: (pagePath: string) =>
      appendPath(new URL(documentationSiteUrl), pagePath).toString(),
  };
};

export default useDocumentationUrl;
